import { createErrorWrapper } from '../utils';

export const SEARCH_ERROR = 'SEARCH.SEACH_ERROR';
export const GET_FILTERS_ERROR = 'SEARCH.GET_FILTERS_ERROR';

export const serachErr = createErrorWrapper(SEARCH_ERROR, 'Failed to load search results');
export const getFiltersErr = createErrorWrapper(GET_FILTERS_ERROR, 'Failed to get default filters');
